<script>
export default {
  name: "MobileMappingInfo",
  data: () => ({
    placeholder: require("@/assets/mobile-mapping-intro.jpg"),
    target: require("@/assets/target.svg"),
    stopwatch: require("@/assets/stopwatch.svg"),
    map: require("@/assets/map.svg"),
    leaf: require("@/assets/leaf.svg"),
    zustand: require("@/assets/mobile-mapping-zustand.png"),
    planning: require("@/assets/mobile-mapping-planning.jpg"),
    documentation: require("@/assets/mobile-mapping-documentation.jpg"),
  })
}
</script>

<template>
<div>
  <div class="h2 mb-5 new-font-medium">Was ist Mobile Mapping?</div>
  <v-row>
    <v-col cols="12" sm="4">
      <img :src="placeholder" style="width: 100%;" />
    </v-col>
    <v-col cols="12" sm="8">
      <div style="height: 100%;" class="mobile-mapping-intro">
        <span>Unser Mobile Mapping Fahrzeug erfasst Straßenzüge berührungslos und dreidimensional im fließenden Verkehr.
        Die entstehenden <b>georeferenzierten Punktwolken</b> und <b>hochauflösenden Panoramabilder</b> bilden eine verlässliche Datengrundlage für die Planung und Dokumentation von Straßen und deren Infrastruktur.<br><br>
          So erfassen wir rund <b>14.000 Kilometer</b> in unserem Konzessionsgebiet, und das effizient, präzise und zukunftsorientiert.</span>
      </div>
    </v-col>
  </v-row>
  <div class="h2 mb-5 new-font-medium spacing-top">Ihre Vorteile mit Mobile Mapping</div>
  <v-row id="benefits-row">
    <v-col cols="12" sm="6" class="benefit-col">
      <div class="benefit-box">
        <v-img :src="target" width="40" height="40" style="margin-bottom: 12px" />
        <b>Präzise Datenerfassung</b>
        <p>Vollständige, berührungslose 3D-Erfassung in nur einem Befahrungsvorgang, und das ganz ohne Verkehrsbeeinträchtigung.</p>
      </div>
    </v-col>
    <v-col cols="12" sm="6" class="benefit-col">
      <div class="benefit-box">
        <v-img :src="stopwatch" width="40" height="40" style="margin-bottom: 12px" />
        <b>Effizienz & Zeitersparnis</b>
        <p>Verlagerung der Vermessung vom Außen- in den Innendienst reduziert klassische Vor-Ort-Einsätze erheblich.</p>
      </div>
    </v-col>
    <v-col cols="12" sm="6" class="benefit-col">
      <div class="benefit-box">
        <v-img :src="leaf" width="40" height="40" style="margin-bottom: 12px" />
        <b>Nachhaltigkeit & CO₂‑Reduktion</b>
        <p>Weniger Folgefahrten durch umfassende Datenerhebung in einem Durchgang und damit ein aktiver Beitrag zum Klimaschutz.</p>
      </div>
    </v-col>
    <v-col cols="12" sm="6" class="benefit-col">
      <div class="benefit-box">
        <v-img :src="map" width="40" height="40" style="margin-bottom: 12px" />
        <b>Kommunaler Mehrwert</b>
        <p>Viewer für Städte und Gemeinden zur eigenen Analyse, d.h. weniger Außentermine, mehr Planung vom Schreibtisch und bessere Entscheidungen.</p>
      </div>
    </v-col>
  </v-row>
  <div class="h2 mb-5 new-font-medium spacing-top">Vielfältiger Einsatz für Kommunen</div>
  <p>
    Die einmal erfassten Daten lassen sich für eine Vielzahl kommunaler Aufgaben nutzen und das ganz ohne eigenen Messeinsatz vor Ort.
  </p>
  <v-row id="usecases-row">
    <v-col cols="12" sm="4" class="benefit-col">
      <div class="benefit-box">
        <img :src="zustand" class="responsive-v-img" style="margin-bottom: 12px" />
        <p class="box-subtitle">Bewertung des Straßenzustands</p>
        <p class="mb-0">Risse, Spurrinnen und Schäden objektiv erfassen und vorausschauend priorisieren</p>
      </div>
    </v-col>
    <v-col cols="12" sm="4" class="benefit-col">
      <div class="benefit-box">
        <img :src="planning" class="responsive-v-img" style="margin-bottom: 12px" />
        <p class="box-subtitle">Planung von Trassen und Leitungen</p>
        <p class="mb-0">Verläufe am Bildschirm prüfen und Maßnahmen planen, statt direkt vor Ort vermessen zu müssen</p>
      </div>
    </v-col>
    <v-col cols="12" sm="4" class="benefit-col">
      <div class="benefit-box">
        <img :src="documentation" style="margin-bottom: 12px" class="responsive-v-img" />
        <p class="box-subtitle">Dokumentation baulicher Anlagen</p>
        <p class="mb-0">Bestand lückenlos festhalten und jederzeit nachvollziehbar abrufen</p>
      </div>
    </v-col>
  </v-row>
</div>
</template>

<style scoped>
.mobile-mapping-intro {
  display: flex;
  align-items: center;
}

.benefit-box {
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding: 16px;
  background: #FFFFFF;
  border-radius: 5px;
}

.benefit-col {
  display: flex;
}
.box-subtitle {
  font-family: "GeometriaMedium", sans-serif;
  font-size: 23px;
  margin-bottom: 16px;
}

.responsive-v-img {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 264/176;
  object-fit: cover;
  object-position: center;
}

</style>
